<!-- Gapless like v1's inline bulkCurationHeaderTemplate string ("Curate this " + adjacent spans,
     no text nodes elsewhere) — preserveWhitespaces:true + inline elements makes any block
     whitespace paint, and this pill is centered so extra spaces shift the whole content. -->
<div class="ft-curation-nav" [class.done]="isDone()">
    <span class="ft-curation-status"><i class="ft-icn-curation-status"></i>Curate this @if (hasPhoto()) {<span>campaign submission</span>}@if (!hasPhoto()) {<span>guest quote</span>}</span>@if (total() > 0) {<a
            class="ft-curation-count"
            (click)="onNext()"
            [style.pointer-events]="!isDone() ? 'none' : null"
            [attr.disabled]="!isDone() ? 'disabled' : null"
        ><span class="ft-count-text">{{ total() }} more</span><i class="ft-icn-caret-right"></i></a>}
</div>
